import React from "react"
import { JSONRPCErrorCatch } from "../../error/error"
import { JSONRPCClientBuilder } from "../../request/JSONRPCClientBuilder"
import { ChatRoomRPC } from "../../rpcs/dist/ChatRoomRPC"
import { Banner } from "./components/banner"
import { Tab, TabList, TabPanel } from "react-tabs"
import { Wrapper } from "../../components/templates/wrapper"
import { Tabs } from "../../components/parts/react-tabs-wrapper"
import { RouteComponentProps } from "react-router-dom"
import Width from "../../style/enum/width"
import { container, IContainerProps } from "./container"
import { ITabData, TabData, TopPagePathNames } from "./data"

const LIVE_DATA_RELOAD_INTERVAL = 30 * 1000

export type IProps = RouteComponentProps<{
  path?: TopPagePathNames
}> &
  IContainerProps

class TopIndex extends React.Component<IProps, {}> {
  private tabPathes: Array<ITabData["path"]>
  private checkLiveChatTimerId: number

  constructor(props: IProps) {
    super(props)
    this.handleSelect = this.handleSelect.bind(this)
    this.tabPathes = TabData(this.props).map(tab => tab.path)
  }

  public async componentDidMount() {
    this.checkNeedsLoad()
  }

  public componentWillUnmount(): void {
    clearTimeout(this.checkLiveChatTimerId)
  }

  public render() {
    const tabData = TabData(this.props)
    return (
      <>
        <Banner />
        <Wrapper maxWidth={Width.EPISODE_LIST}>
          <Tabs onSelect={this.handleSelect} selectedIndex={this.getTabIndex()}>
            <TabList>
              {tabData.map((tab, i) => (
                <Tab key={i}>{tab.title}</Tab>
              ))}
            </TabList>
            {tabData.map((tab, i) => (
              <TabPanel key={i}>{tab.component}</TabPanel>
            ))}
          </Tabs>
        </Wrapper>
      </>
    )
  }

  private getTabIndex() {
    if (!this.props.match.params.path) {
      return 0
    }
    const index = this.tabPathes.indexOf(this.props.match.params.path)
    return index || 0
  }

  private handleSelect(index: number) {
    const tabPath = this.tabPathes[index] || ""
    if (this.props.match.params.path !== tabPath) {
      this.props.history.push(tabPath)
    }
  }

  private async checkNeedsLoad() {
    const { updatedAt } = this.props.top.lives
    if (!updatedAt || updatedAt + LIVE_DATA_RELOAD_INTERVAL < Date.now()) {
      this.loadLiveInfo()
    }
    this.checkLiveChatTimerId = setTimeout(() => {
      this.checkNeedsLoad()
    }, 1000)
  }

  private async loadLiveInfo() {
    const chatRoomRPC = JSONRPCClientBuilder.build(ChatRoomRPC)
    const res = await chatRoomRPC.fetchLiveChatRooms().catch(JSONRPCErrorCatch)
    if (res !== -1) {
      this.props.actions.updateLives(res.reverse())
    }
  }
}

export default container(TopIndex)
